const getSystemInfo = async () => {
  const isNfPlus = await window.nfplusJsbridge.getInsideVersion()
  const os = {
    isNfPlus: !!isNfPlus
  }
  return os
}

export default getSystemInfo
